export function toHumanReadable(str: string) {
  return str
    .split(/(?=[A-Z])/)
    .join(' ')
    .replace(/^./, (text) => text.toUpperCase());
}
